import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  href?: string;
  onTrack?: () => Promise<void>;
}
export function Button({
  children,
  href,
  className = '',
  onTrack,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-block w-full md:w-auto text-center bg-brand-green hover:bg-brand-greenHover text-white font-bold py-4 px-8 rounded-lg shadow-lg transition-colors duration-300 text-lg md:text-xl cursor-pointer';
  const content = <motion.div whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-1">
      {children}
    </motion.div>;
  const handleClick = async (e: React.MouseEvent) => {
    if (href && onTrack) {
      e.preventDefault();
      await onTrack();
      window.location.href = href;
    } else if (onTrack) {
      await onTrack();
    }
  };
  if (href) {
    return <a href={href} className={`${baseStyles} ${className}`} onClick={onTrack ? handleClick : undefined} data-id="element-2">
        {content}
      </a>;
  }
  return <button className={`${baseStyles} ${className}`} onClick={onTrack ? handleClick : undefined} {...props} data-id="element-3">
      {content}
    </button>;
}